import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { KundorderService } from "../../kundorder/kundorder.service";
import { IKundorderDetailKundorder } from "../../kundorder/models/kundorder-detail-model";
import { ICopyOrderHeader, ICopyOrderPreview } from "./copy-order.models";

@Injectable({
    providedIn: "root"
})
export class CopyOrderService {
    private readonly kundorderService = inject(KundorderService);

    getPreview(id: number): Observable<ICopyOrderPreview> {
        return this.kundorderService.get(id)
            .pipe(map(res => {
                res.kundorderrader.forEach(x => {
                    x.kopiera = true;
                    x.kvantitet = undefined;
                    x.periodFrom = undefined;
                    x.periodTom = undefined;
                });

                return {
                    header: this.mapHeader(res),
                    order: res
                };
            }));
    }

    private mapHeader(source: IKundorderDetailKundorder): ICopyOrderHeader {
        return {
            huvudkodInternnummer: source.huvudkodInternnummer,
            besokAdress: source.besokAdress,
            ordernummer: source.ordernummer,
            mattslag: source.mattslag,
            summaLeveransrader: this.kundorderService.getSummaLeveransrader(source.kundorderrader),
            periodFrom: undefined,
            periodTom: undefined
        };
    }

}
